import type { FaireProductEntity } from "../../entity_types/product";

export const p_vkva66tczr: FaireProductEntity = {
  token: "p_vkva66tczr",
  type: "product",
  name: "Citrine Heart Ring White Bronze size 7 & 8 only",
  brandToken: "b_edj9u7j4sq",
  brandName: "KayleeNYC",
  imageUrl:
    "https://cdn.faire.com/fastly/9e9b3bc98245c2feceaaa7b1ec0bfff3ba3c34b090754e2b1977aab561fe5ad7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5ff2792ba73ba31d1d98a9b876a0b8b8c0787b45b4844fe502220ad964c40fe0.jpeg",
    "https://cdn.faire.com/fastly/f4d274765a55b9d21c5818cf0dc3b73ac82b1e1a26d3c3cf72acb47fa280e544.jpeg",
    "https://cdn.faire.com/fastly/125714257eb3cf24a0aa049fb39cd6659e28a83e861adcd5b5227138c4e88c64.jpeg",
    "https://cdn.faire.com/fastly/dca75becd0f2a7afdb39f5828f5e0368e6f6b31480ecd2de90324aac34b9d54f.jpeg",
  ],
  priceDollars: 4.3,
  description:
    "Citrine White Bronze Heart ring. Size of the Citrine are roughly around 5mm each. You will receive 3 size 7 and 3 size 8. White Bronze rings are hypoallergenic and doesn't contain lead. Minimum order 6 pcs. Condition is New. \n\nFree local pickup in Brooklyn, New York.  \n\nStones, crystals, crystal jewelry, crystal bulk, spiritual, meditation, metaphysical wholesale. \n",
  tags: [],
  msrpDollars: 8.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:51.780Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
